<template>
  <div>
    <px-view-header title="Meu painel" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasRoleComprador || hasRoleRequisicao || hasRoleGestorCompras">
        <px-meu-painel-requisicoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasRoleAprovadorRequisicao || hasRoleGestorCompras">
        <px-meu-painel-aprovacoes-solicitacoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
        v-if="hasRoleComprador || hasRoleGestorCompras">
        <px-meu-painel-cotacoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasRoleComprador || hasRoleAprovador || hasRoleGestorCompras">
        <px-meu-painel-aprovacoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasRoleAprovador
              || hasRoleComprador || hasRoleGestorCompras">
        <px-meu-painel-compras/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasIntegracaoAtiva && (hasRoleAprovador
              || hasRoleComprador || hasRoleGestorCompras)">
        <px-meu-painel-compras-pendente-integracao/>
      </v-col>
    </v-row>
    <v-row v-if="hasModuleGestorFrete">
      <v-col cols="12" md="12" lg="6">
        <px-meu-painel-cotacoes-frete/>
      </v-col>
      <v-col cols="12" md="12" lg="6">
        <px-meu-painel-contratacoes-frete/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MeuPainelRequisicoes from '@/modules/meu-painel/MeuPainelRequisicoes.vue';
import MeuPainelAprovacoes from '@/modules/meu-painel/MeuPainelAprovacoes.vue';
import MeuPainelAprovacoesSolicitacoes
  from '@/modules/meu-painel/MeuPainelAprovacoesSolicitacoes.vue';
import MeuPainelCotacoes from './MeuPainelCotacoes.vue';
import MeuPainelCompras from './MeuPainelCompras.vue';
import MeuPainelComprasPendenteIntegracao from './MeuPainelComprasPendenteIntegracao.vue';
import MeuPainelCotacoesFrete from './MeuPainelCotacoesFrete.vue';
import MeuPainelContratacoesFrete from './MeuPainelContratacoesFrete.vue';

export default {
  data() {
    return {
      integracaoIniciada: false,
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Meu painel' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleAprovadorRequisicao', 'hasModuleGestorFrete', 'hasRoleRequisicao', 'hasRoleAprovador', 'hasRoleGestorCompras']),
    ...mapGetters('entidade', ['hasIntegracaoAtiva']),
  },
  components: {
    pxMeuPainelCotacoes: MeuPainelCotacoes,
    pxMeuPainelCompras: MeuPainelCompras,
    pxMeuPainelComprasPendenteIntegracao: MeuPainelComprasPendenteIntegracao,
    pxMeuPainelCotacoesFrete: MeuPainelCotacoesFrete,
    pxMeuPainelContratacoesFrete: MeuPainelContratacoesFrete,
    pxMeuPainelRequisicoes: MeuPainelRequisicoes,
    pxMeuPainelAprovacoes: MeuPainelAprovacoes,
    pxMeuPainelAprovacoesSolicitacoes: MeuPainelAprovacoesSolicitacoes,
  },
};
</script>
